// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E5yYx","top":"styles_top__2_EdD"};